export default __webpack_public_path__ + "static/media/School_Collage.f49a2a20.png";